import { Component } from 'preact';
import RaffleCard from './RaffleCard';
import style from './styles/RaffleList.scss';
import LoadingSpinner from '../spinner/LoadingSpinner';
import Promo from '../promo/Promo';

/**
 * @property {Raffle[]} props.raffles
 * @property {boolean} props.moreAvailable
 * @property {Function} props.fetchMore
 */
// eslint-disable-next-line react/prefer-stateless-function
export default class RaffleList extends Component {

	/**
	 * Fetch additional raffles
	 */
	fetchMore = () => {
		if (!this.props.fetching && this.props.moreAvailable) {
			this.props.fetchMore(this.props.page + 1);
		}
	};

	render({ items, fetching, moreAvailable, className, hasPromo, suggestedShopId }) {
		if (items.length < 1) {
			return null;
		}

		return (
			<div className={`${style['raffle-list']} ${className}`}>
				<RaffleRow
					raffles={items}
					hasPromo={hasPromo}
					suggestedShopId={suggestedShopId}
				/>
				{ moreAvailable === true ? (
					<div className="row text-center">
						<div className="col-12">
							<div className={style['show-more']} onClick={this.fetchMore}>Show More</div>
						</div>
						<LoadingSpinner active={fetching} />
					</div>
				) : null }
			</div>
		);
	}
}

// no-padding
const RaffleRow = ({ raffles, hasPromo, suggestedShopId }) => {
	let items;

	const PROMO_ID = '__promo__';

	if (hasPromo) {
		items = raffles.slice();

		items.splice(1, 0, { id: PROMO_ID });
	}
	else {
		items = raffles;
	}

	return (
		<div className="row">
			{ items.map(raffle => (
				<div key={raffle.id} className={`col-xl-4 col-lg-6 col-md-6 col-sm-12 ${style['raffle-item']}`}>
					{raffle.id === PROMO_ID
						? <Promo suggestedShopId={suggestedShopId} />
						: <RaffleCard raffle={raffle} />
					}
				</div>
			))}
		</div>
	);
};



// WEBPACK FOOTER //
// ./components/raffle/RaffleList.js